
class PreviewComponent extends Game.src.component.BaseComponent {

    onGameReady() {
        super.onGameReady();

        game.onData('game.keybord.ON_KEY_DOWN', {"code": "KeyP"}, this.togglePreviewSprite);
    }

    togglePreviewSprite() {
        const wrapper = game.tree.findByName('preview.sprite_wrapper');

        wrapper.options.visible = !Boolean(wrapper.options.visible);
        wrapper.forceViewUpdate();
    }
}

// @ts-ignore
Game.src.component.PreviewComponent = PreviewComponent;
